// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-display-container {
  display: grid;
  grid-template-rows: auto 30px;
  grid-gap: 16px;
  height: 100%;
}

.action-buttons {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 80px;
  justify-content: end;
}
.action-buttons #validation-message {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: auto 1fr;
  line-height: 26px;
  padding: 0;
}
.action-buttons #validation-message #button-undo {
  height: 34px;
  width: 34px;
  border-radius: 50%;
  text-align: center;
  margin: 0;
  font-size: 10px;
  padding: 0;
}
.action-buttons #validation-message .show-undo {
  animation: fadein 1.5s;
  display: block;
}
.action-buttons #validation-message .disabled {
  animation: fadeout 0.5s;
}
.action-buttons #validation-message .valid-equation {
  animation: fadein 1.5s;
  color: #72bf44;
}
.action-buttons #validation-message .invalid-equation, .action-buttons #validation-message .invalid-equation-link {
  animation: fadein 1.5s;
  color: #f07d23;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.action-buttons #validation-message .invalid-equation-link {
  text-decoration: underline;
  cursor: pointer;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.action-buttons button {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/simulation/import-alm-dataset/import-error-display/import-error-display.component.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,6BAAA;EACA,cAAA;EACA,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,cAAA;EACA,2BAAA;EACA,oBAAA;AAFF;AAIE;EACE,aAAA;EACA,cAAA;EACA,+BAAA;EACA,iBAAA;EACA,UAAA;AAFJ;AAII;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;AAFN;AAKI;EACE,sBAAA;EACA,cAAA;AAHN;AAMI;EACE,uBAAA;AAJN;AAQI;EACE,sBAAA;EACA,cA7CE;AAuCR;AAQI;EACE,sBAAA;EACA,cAhDG;EAiDH,uBAAA;EACA,mBAAA;EACA,gBAAA;AANN;AAQI;EAEE,0BAAA;EACA,eAAA;AAPN;AAUI;EACE;IACE,UAAA;EARN;EAUI;IACE,UAAA;EARN;AACF;AAUI;EACE;IACE,UAAA;EARN;EAUI;IACE,UAAA;EARN;AACF;AAYE;EACE,WAAA;AAVJ","sourcesContent":["$green: #72bf44;\r\n$orange: #f07d23;\r\n\r\n.error-display-container {\r\n  display: grid;\r\n  grid-template-rows: auto 30px;\r\n  grid-gap: 16px;\r\n  height: 100%;\r\n}\r\n\r\n.action-buttons {\r\n  display: grid;\r\n  grid-gap: 16px;\r\n  grid-template-columns: 80px;\r\n  justify-content: end;\r\n\r\n  #validation-message {\r\n    display: grid;\r\n    grid-gap: 16px;\r\n    grid-template-columns: auto 1fr;\r\n    line-height: 26px;\r\n    padding: 0;\r\n\r\n    #button-undo {\r\n      height: 34px;\r\n      width: 34px;\r\n      border-radius: 50%;\r\n      text-align: center;\r\n      margin: 0;\r\n      font-size: 10px;\r\n      padding: 0;\r\n    }\r\n\r\n    .show-undo {\r\n      animation: fadein 1.5s;\r\n      display: block;\r\n    }\r\n\r\n    .disabled {\r\n      animation: fadeout 0.5s;\r\n      // display: none;\r\n    }\r\n\r\n    .valid-equation {\r\n      animation: fadein 1.5s;\r\n      color: $green;\r\n    }\r\n    .invalid-equation {\r\n      animation: fadein 1.5s;\r\n      color: $orange;\r\n      text-overflow: ellipsis;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n    }\r\n    .invalid-equation-link {\r\n      @extend .invalid-equation;\r\n      text-decoration: underline;\r\n      cursor: pointer;\r\n    }\r\n\r\n    @keyframes fadein {\r\n      from {\r\n        opacity: 0;\r\n      }\r\n      to {\r\n        opacity: 1;\r\n      }\r\n    }\r\n    @keyframes fadeout {\r\n      from {\r\n        opacity: 1;\r\n      }\r\n      to {\r\n        opacity: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  button {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
